/* eslint-disable */
// Copied function, not applying `eslint` rules to keep it as is

import type MagicString from 'magic-string';
import type { ResolvedConfig } from 'vite';
import type { ImportSpecifier } from 'es-module-lexer';
import { transformCjsImport } from './transformCjsImport.js';
import { getLineBreaks, interopHelper } from './utils.js';

// https://github.com/vitejs/vite/blob/4e5ce3c7a90966b1f942df35b8b3e8a550a4f031/packages/vite/src/node/plugins/importAnalysis.ts#L865-L917
export function interopNamedImports(
  str: MagicString,
  importSpecifier: ImportSpecifier,
  rewrittenUrl: string,
  importIndex: number,
  importer: string,
  config: ResolvedConfig
): void {
  const source = str.original;
  const {
    s: start,
    e: end,
    ss: expStart,
    se: expEnd,
    d: dynamicIndex,
  } = importSpecifier;
  const exp = source.slice(expStart, expEnd);
  if (dynamicIndex > -1) {
    // rewrite `import('package')` to expose the default directly
    str.overwrite(
      expStart,
      expEnd,
      `import('${rewrittenUrl}').then(m => (${interopHelper.toString()})(m.default))` +
        getLineBreaks(exp),
      { contentOnly: true }
    );
  } else {
    const rawUrl = source.slice(start, end);
    const rewritten = transformCjsImport(
      exp,
      rewrittenUrl,
      rawUrl,
      importIndex,
      importer,
      config
    );
    if (rewritten) {
      str.overwrite(expStart, expEnd, rewritten + getLineBreaks(exp), {
        contentOnly: true,
      });
    } else {
      // #1439 export * from '...'
      str.overwrite(
        start,
        end,
        rewrittenUrl + getLineBreaks(source.slice(start, end)),
        {
          contentOnly: true,
        }
      );
    }
  }
}
